import * as React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconUI from "./NavaIcon";

import { useHistory } from "react-router-dom";
import Navigation from "./Navigation";
import { Collapse, Divider, List } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { useState } from "react";

const MainListItems = props => {
  return (
    <div>
      {Navigation.map((nav, i) => {
        return (
          <ChildrenItems key={i} menu={nav} />
        );
      })}
    </div>
  );
}

const ChildrenItems = props => {
  const [open, setOpen] = useState(false);
  const history = useHistory();  
  const handleClick = () => {
    setOpen(!open);
  };  
  const { menu } = props;  
  return (
    <div>
      <ListItem button key={menu.id} onClick={handleClick}>
        <ListItemIcon>
          <IconUI icon={menu.icon} style={{ fontSize: 'xx-large' }}
            onClick={() => { history.push(menu.url) }} />
        </ListItemIcon>
        <ListItemText primary={menu.title} onClick={() => { history.push(menu.url) }} />
        {menu.children && (open ? <ExpandLess /> : <ExpandMore />)}
      </ListItem>
      {menu.children && (
        <Collapse
          key={menu.children.id}
          in={open}
          timeout='auto'
          unmountOnExit
        >
          <List component='li' disablePadding key={menu.Id}>
            {menu.children.map(children => {
              return (
                <ListItem button key={children.id}>
                  <ListItemIcon>
                      {/* <InsertDriveFileTwoToneIcon /> */}
                  </ListItemIcon>
                  <ListItemText key={children.id} primary={children.title}
                    onClick={() => { history.push(children.url) }} />
                </ListItem>
              );
            })}
          </List>
        </Collapse>
      )}
      <Divider />
    </div>
  )
}

export { MainListItems };
